import React, { useEffect, useState } from 'react';
import CountdownTimer from './CountdownTimer';

interface TimerLoaderProps {
  clearMode?: boolean;
}

const TimerLoader: React.FC<TimerLoaderProps> = ({ clearMode }) => {
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [endTime, setEndTime] = useState<Date | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/config/event-timer.json')
      .then(res => {
        if (!res.ok) throw new Error('設定ファイルの取得に失敗しました');
        return res.json();
      })
      .then(data => {
        setStartTime(new Date(data.startTime));
        setEndTime(new Date(data.endTime));
        setLoading(false);
      })
      .catch(e => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>タイマー設定を読み込み中...</div>;
  if (error || !startTime || !endTime) return <div>タイマー設定エラー: {error}</div>;

  return <CountdownTimer startTime={startTime} endTime={endTime} clearMode={clearMode} />;
};

export default TimerLoader;
